import { Plus } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function PlusIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Plus
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
